import { Injectable } from '@angular/core';
import { ILoginProviderRequest } from '@core/models/admin/account/login-providers.model';
import { UserInterfaceChangeStatus } from '@core/models/admin/application/applicationuser.model';
import { EndpointConstants } from '@core/services/endpoints-configurations/endpoint-constants';
import { Observable } from 'rxjs';
import { IAccountInfo } from '../../../models/admin/account/accountInfo.model';
import {
  IAuthPhoneNumber,
  ICompanyModel,
  IEmailModel,
  IImageProfileModel,
  INameModel,
  IPasswordModel,
  IPhoneModel,
} from '../../../models/admin/account/profile.model';
import { IUserModel } from '../../../models/shared/user.model';
import { HttpClientRequestService } from '../../../request-services/httpclient.request.services';

@Injectable({
  providedIn: 'root',
})
export class AccountRepositoryService {
  constructor(private repo: HttpClientRequestService) {}

  accountinfo(request: IAccountInfo): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiAccountinfo;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  saveAccountInfo(request: IUserModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdateaccountinfo;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  saveNames(request: INameModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdatename;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  saveCompany(request: ICompanyModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdatecompany;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  saveEmail(request: IEmailModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdateemail;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  savePhone(request: IPhoneModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdatephone;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  savePassword(request: IPasswordModel): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdatepassword;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  saveImageProfile(request: IImageProfileModel): Observable<any> {
    // const formData = new FormData();
    // formData.append('image', image);
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdateimageprofile;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  accountconfiguration(request: IAccountInfo): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiAccountconfiguration;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  UpdateStatusUser(request: UserInterfaceChangeStatus): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdateuserstatus;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  EnableDisableB2CUuser(request: UserInterfaceChangeStatus): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiEnabledisableb2cuser;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  UpdateLoginProvider(request: ILoginProviderRequest): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdateLoginProvider;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  UpdateExternalProviderB2C(request: ILoginProviderRequest): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiUpdateCompanynameB2CExternalUser;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  GetLoginProviders(request: ILoginProviderRequest): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiGetLoginProviders;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  DeleteExternalProviderB2C(request: ILoginProviderRequest): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiDeleteB2CExternalUser;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }

  saveAuthPhoneNumber(request: IAuthPhoneNumber): Observable<any> {
    return new Observable((subcriber) => {
      const url: string = EndpointConstants.ApiAddOrUpdateAuthPhoneNumber;
      this.repo.post(url, request).subscribe(
        (value) => {
          subcriber.next(value);
        },
        (error) => {
          subcriber.error(error);
        },
      );
    });
  }
}
